import { h } from 'preact';
import React, { Component } from 'react';
import LinkSVG from '../Components/Link.svg';
import Accordion from '../Components/Accordion';
import { makeText, formatDescription } from '../../../util';

const Tag = ({ vendor, accordionOpen }) => (
  <a tabIndex={accordionOpen ? 0 : -1} href={vendor.policyUrl} target="_blank" className="vendor-tag linked">
    <span>{vendor.name}</span>
    <img src={LinkSVG} alt="" />
  </a>
);

const FeatureContent = ({ feature, accordionOpen, settings }) => {
  if (settings.alphabetizeVendors) {
    if (feature && feature.vendors) {
      feature.vendors.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
        if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
        return 0;
      });
    }
  }
  return (
    <div className="feature-content">
      {formatDescription(feature.description)}
      {feature.vendors.length > 0 && (
        <div className="policies">
          {feature.vendors.map(v => <Tag vendor={v} accordionOpen={accordionOpen} />)}
        </div>
      )}
    </div>
  )
};

export default class Features extends Component {
  render() {
    const {
      features,
      specialFeatures,
      settings,
      language,
      dev,
    } = this.props;
    const featuresText = makeText(Boolean(dev), settings, 'featuresText', language);
    const featuresInfo = makeText(Boolean(dev), settings, 'featuresInfo', language);
    const specialFeaturesText = makeText(Boolean(dev), settings, 'specialFeaturesText', language);
    const specialFeaturesInfo = makeText(Boolean(dev), settings, 'specialFeaturesInfo', language);

    return (
      <div className="pm-features">
        {features.length > 0 && (
          <>
            <h2
              id='features-focus'
              tabindex='0'
              className="info-title"
            >
              {featuresText}
            </h2>
            <p className="pm-sub-p">{featuresInfo}</p>
            {features.map((f, i) => (
              <Accordion
                key={`purpose-${f._id}`}
                settings={this.props.settings}
                name={f.name}
                child="features"
                language={language}
                value={f}
                description={f.description}
                content={<FeatureContent feature={f} settings={settings} />}
                index={i}
              />
            ))}
          </>
        )}

        {specialFeatures.length > 0 && (
          <>
            <h2 className="info-title">{specialFeaturesText}</h2>
            <p className="pm-sub-p">{specialFeaturesInfo}</p>
            {specialFeatures.map((f, i) => (
              <Accordion
                key={`special-purpose-${f._id}`}
                settings={this.props.settings}
                name={f.name}
                child="features"
                language={language}
                value={f}
                vendors={f.vendors}
                description={f.description}
                content={<FeatureContent feature={f} settings={settings} />}
                toggle={this.props.togglePurposeOrFeature}
                dev={dev}
                index={i}
              />
            ))}
          </>
        )}

      </div>
    );
  }
}
